import Vue from 'vue'
import InstantSearch from 'vue-instantsearch'

// Make sure to pick a unique name for the flag
// so it won't conflict with any other mixin.
if (!Vue.__psg_algolia__) {
  Vue.__psg_algolia__ = true
  Vue.use(InstantSearch)
}
